<template>
    <div class="list"
         v-if="data">
        <ul>
            <li v-for="(item,index) in data"
                :key="index">
                <OnlyTitle v-if="item.displayType == 1"
                           :url="item.shareUrl"
                           :title="item.title"
                           :source="item.source"
                           :createTime="item.createTime * 1000"
                           >
                </OnlyTitle>

                <TopTitleBottomImage v-else-if="item.displayType == 2"
                                     :url="item.shareUrl"
                                     :title="item.title"
                                     :image="item.images[0] || ''"
                                     :source="item.source"
                                     :createTime="item.createTime * 1000"
                                     >
                </TopTitleBottomImage>

                <OneTitleThreeImage v-else-if="item.displayType == 3"
                                    :url="item.shareUrl"
                                    :title="item.title"
                                    :images="item.images"
                                    :source="item.source"
                                    :createTime="item.createTime * 1000"
                                    >
                </OneTitleThreeImage>

                <LeftTitleRightImage v-else-if="item.displayType == 4"
                                     :url="item.shareUrl"
                                     :title="item.title"
                                     :image="item.images[0] || ''"
                                     :source="item.source"
                                     :createTime="item.createTime * 1000"
                                     >
                </LeftTitleRightImage>

                <TopTitleThreeImage v-else-if="item.displayType == 5"
                                    :url="item.shareUrl"
                                    :title="item.title"
                                    :images="item.images"
                                    :source="item.source"
                                    :createTime="item.createTime * 1000"
                                    >
                </TopTitleThreeImage>

                <OnlyTitle v-else
                           :url="item.shareUrl"
                           :title="item.title"
                           :source="item.source"
                           :createTime="item.createTime * 1000"
                           >
                </OnlyTitle>
            </li>
        </ul>
        <div class="load-box" v-if="data.length > 0">
            <a href="javascript:;" @click="pageChange">{{topic}}</a>
        </div>
    </div>
</template>

<script>
import List from "../list/index";

export default {
    name: "News",
    props: {
        data: Array,
        cateId: Number,
        topic: String
    },
    data(){
        return{
            dataList: [],
            page: 1
        }
    },
    methods:{
        pageChange(){
            this.page++;
            this.$emit('getNewList', this.page)
        }
    },
    mounted(){
        if (window.navigator.userAgent.indexOf('ZgApp') >= 0) {
            let list = document.querySelector('.list');
            list.style.paddingBottom = 0;
        }
    },
    components: {
        OnlyTitle: List.OnlyTitle,
        TopTitleBottomImage: List.TopTitleBottomImage,
        OneTitleThreeImage: List.OneTitleThreeImage,
        LeftTitleRightImage: List.LeftTitleRightImage,
        TopTitleThreeImage: List.TopTitleThreeImage,
    }
}
</script>

<style scoped>
.list{
    padding-bottom: 1.5rem;
}
ul li {
    margin: 0 0.3rem;
    padding: 0.4rem 0;
    border-bottom: 1px solid rgba(221, 221, 221, 0.6);
}
.load-box{
    text-align: center;
}
.load-box a{
    padding: 0.35rem 0;
    font-size: 0.36rem;
    color: #333;
    display: block;
}
</style>
